import React from 'react'

import {
  Button,
  Input,
  ModalBox,
  useCopyToClipboard,
  useModalContext,
} from '@fourthwall/components'
import { DuplicateIcon } from '@fourthwall/icons'

import * as S from './CheckoutUrlSetupModal.styled'

type CheckoutUrlSetupModalProps = {
  metaCommerceCheckoutSetupUri: string
  fwCheckoutRedirectUri: string
}

export const CheckoutUrlSetupModal = ({
  metaCommerceCheckoutSetupUri,
  fwCheckoutRedirectUri,
}: CheckoutUrlSetupModalProps) => {
  const { close } = useModalContext()
  const { copyToClipboard } = useCopyToClipboard()

  return (
    <ModalBox title="Set up your Meta checkout URL" size="large" onClose={close}>
      <S.ContentContainer>
        <S.Description>
          This URL allows Meta to direct customers to Fourthwall checkout when they purchase from
          your Instagram or Facebook shop.
        </S.Description>

        <S.StepsList>
          <S.StepItem>
            <S.StepNumber>1.</S.StepNumber>
            <S.StepContent>Enter Meta setup process by clicking on button below:</S.StepContent>
          </S.StepItem>

          <S.ButtonContainer>
            <Button
              appearance="primary"
              label="Set up your checkout URL"
              href={metaCommerceCheckoutSetupUri}
              target="_blank"
            />
          </S.ButtonContainer>

          <S.StepItem>
            <S.StepNumber>2.</S.StepNumber>
            <S.StepContent>Copy checkout URL domain and paste it in the Meta setup:</S.StepContent>
          </S.StepItem>

          <S.UrlInputContainer>
            <S.InputWrapper>
              <Input readOnly value={fwCheckoutRedirectUri} fullWidth />
            </S.InputWrapper>
            <Button
              appearance="secondary"
              label="Copy URL"
              leftIcon={<DuplicateIcon />}
              onClick={() => copyToClipboard(fwCheckoutRedirectUri)}
            />
          </S.UrlInputContainer>

          <S.StepItem>
            <S.StepNumber>3.</S.StepNumber>
            <S.StepContent>Finish your setup on Meta and save your settings.</S.StepContent>
          </S.StepItem>

          <S.StepItem>
            <S.StepNumber>4.</S.StepNumber>
            <S.StepContent>Your Meta shop should be working now!</S.StepContent>
          </S.StepItem>
        </S.StepsList>
      </S.ContentContainer>
    </ModalBox>
  )
}
